import { webtoons } from "@/mocks/webtoons";

export default function Featured() {
  const picks = webtoons.filter((w) => w.editorsPick);

  return (
    <section id="featured" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="flex flex-col gap-2">
          <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
            <i className="ri-fire-fill"></i>
            编辑精选
          </span>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            本周最值得入坑的三部韩漫
          </h2>
          <p className="text-sm text-foreground-600 md:text-base">
            编辑团队反复试读后的心头好，高分、高口碑，闭眼入不踩雷。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-3">
          {picks.map((w, idx) => (
            <article
              key={w.id}
              className="group flex flex-col overflow-hidden rounded-lg bg-background-100 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-[4/5] w-full overflow-hidden">
                <img
                  src={w.cover}
                  alt={`${w.title}韩漫封面推荐`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                  No.{idx + 1} 编辑精选
                </span>
                <span className="absolute bottom-3 right-3 rounded-full bg-background-950/70 px-3 py-1 text-xs font-medium text-background-50 backdrop-blur">
                  豆瓣 {w.score}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <div className="flex items-center gap-2">
                  <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-medium text-secondary-900">
                    {w.genreLabel}
                  </span>
                  <span className="text-xs text-foreground-500">{w.status}</span>
                </div>
                <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950">
                  {w.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  {w.highlight}
                </p>
                <div className="mt-3 flex flex-wrap gap-1.5">
                  {w.tags.map((t) => (
                    <span key={t} className="text-xs text-accent-700">
                      #{t}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}